import { render, staticRenderFns } from "./RegionPicker.vue?vue&type=template&id=2f6aae7d&scoped=true"
import script from "./RegionPicker.vue?vue&type=script&lang=js"
export * from "./RegionPicker.vue?vue&type=script&lang=js"
import style0 from "./RegionPicker.vue?vue&type=style&index=0&id=2f6aae7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6aae7d",
  null
  
)

export default component.exports